// supportChatSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface SupportChatState {
    allSupportChats: any[]
    allSupportChatsLoading: boolean
}

const initialState: SupportChatState = {
    allSupportChats: [],
    allSupportChatsLoading: false,
}

const supportChatSlice = createSlice({
    name: "supportChat",
    initialState,
    reducers: {
        setAllSupportChats: (state, action: PayloadAction<any[]>) => {
            return { ...state, allSupportChats: action.payload }
        },
        setAllSupportChatsLoading: (state, action: PayloadAction<boolean>) => {
            return { ...state, allSupportChatsLoading: action.payload }
        },
    },
})

export const { setAllSupportChats, setAllSupportChatsLoading } =
    supportChatSlice.actions

export const supportChatSelector = (state: { supportChat: SupportChatState }) =>
    state.supportChat

export default supportChatSlice.reducer
